import { cn } from '@/utils/tailwind';

type PullToRefreshSpinnerProps = {
  className?: string;
  progress?: number; // 0-100, 당기는 정도
};

/** iOS 기본 스타일 스피너 */
export const PullToRefreshSpinner = ({ className, progress = 0 }: PullToRefreshSpinnerProps) => {
  const bars = 12; // 막대 개수
  const isSpinning = progress >= 100; // 100%일 때만 회전

  return (
    <div className={cn('relative h-[24px] w-[24px]', className)}>
      <div
        className={cn('relative h-full w-full', isSpinning && 'animate-spin')}
        style={{
          animationDuration: '0.8s',
          animationTimingFunction: 'linear',
          willChange: 'transform',
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden',
        }}
      >
        {Array.from({ length: bars }).map((_, index) => {
          const rotation = (index * 360) / bars;

          const threshold = (index / bars) * 100;
          const isVisible = progress >= threshold;

          const baseOpacity = isSpinning
            ? 1 - (index / bars) * 0.75
            : isVisible
            ? 0.2 + (index / bars) * 0.8
            : 0.1;

          return (
            <div
              key={index}
              className="absolute"
              style={{
                width: '2px',
                height: '6px',
                borderRadius: '1px',
                backgroundColor: '#8E8E93',
                left: '50%',
                top: '50%',
                transform: `translate(-50%, -50%) rotate(${rotation}deg) translateY(-9px)`,
                transformOrigin: 'center center',
                opacity: baseOpacity,
                willChange: 'opacity',
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
